export default "__VITE_ASSET__e2927b42__"